import { FormProvider, useForm } from "react-hook-form";
import { Button, Form } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { guardarCorreoSchema } from "./schemas";
import { stringMensajePara } from "../handlers";
import { MuniSpinner2, TextInput } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { handleGuardarCorreo } from "./handlers";
// import { handleGuardarCorreo } from "./handlers";
// import { Slider } from "@mui/material";
import BlockIcon from '@mui/icons-material/Block';
// import { useState } from "react";

const FormGuardarCorreo = (props) => {
  const { handlerModal, loads, handlerLoading } = useGeneralAppStore();
  const { valor, setValor, datosSobre, setDatosSobre, setCorreoElectronico, verify, setVerify } = props;
  // const [value, setValue] = useState(0);

  const methods = useForm({
    mode: "all",
    resolver: yupResolver(guardarCorreoSchema),
    defaultValues: {
      valor: valor,
      datos_sobre: datosSobre,
      correo_electronico: "",
      telefono: "",
    },
  });

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  return (
    <FormProvider {...methods}>
      <form
        className="position-relative"
        onSubmit={
          methods.handleSubmit((data) => {
            setCorreoElectronico(data.correo_electronico);
            return handleGuardarCorreo(data, setValor, setDatosSobre, setCorreoElectronico, setVerify, handlerLoading)
            
            // handlerModal({ modal: true, modalName: "captcha" }
            // handleGuardarCorreo(data, setValor, setDatosSobre)
            // )
          }
          )
        }
      >

        <fieldset className="d-flex flex-column gap-3" disabled={methods.formState.isSubmitting}>
          <label className="font-lowercase">
            ¿Desea recibir un aviso cuando se detecte una infracción  {stringMensajePara(valor, datosSobre)}?
          </label>

          <TextInput name="correo_electronico" label="Correo Electrónico *" />
          <TextInput type="number" name="telefono" label="Teléfono (opcional)" />
          {
            methods.watch('correo_electronico') != "" && Object.keys(methods.formState.errors).length === 0 && (
              <div className="d-flex flex-row gap-2">
                <Form.Check 
                defaultChecked={verify}
                id="verify" name="verify" disabled={verify} onChange={(e) => { e.target.checked && handlerModal({ modal: true, modalName: "captcha" }) }} />
                <Form.Label htmlFor="verify" style={{marginTop: "2px"}}>No soy un robot *</Form.Label>
              </div>
            )

          }

          {/* <div className="d-flex flex-column gap-0">
          <Slider onChange={handleChange} color="#1334C9"/>
        </div> */}
          <Button
            type="submit"
            disabled={methods.formState.isSubmitting || !verify}
            size="lg"
            className="d-flex justify-content-center"
          >
            {methods.formState.isSubmitting ? (
              <span className="d-flex align-items-center gap-1">
                <MuniSpinner2
                  width="18px"
                  height="18px"
                  circularProgressSize={24}
                  circularProgressColor="#ffffff"
                  fileName="bola-blanca.png"
                />
              </span>
            ) :
              // (
              //   value !== 100 ? "Mueva el slider hacia el final para guardar el correo electrónico" : "Guardar Correo Electrónico"
              // )
              <>
                {verify ? 
                "Enviar Información" : <BlockIcon/>
                }
              
              </>
            }
          </Button>
        </fieldset>
      </form>
    </FormProvider>
  );
};

export default FormGuardarCorreo;
